/* eslint-disable camelcase */
import { ApiService } from '~/shared/api'
import { VacancyIntegrationModel } from '~/model/AccountVacancies'
import { isUnknownObject } from '~/shared/utils/guards'
import type { IntegrationsParams, ImportVacancyParams } from '~/interfaces/AccountVacancies'

interface IntegrationData {
  name: string
  id: number
  status: string
  is_enabled?: boolean | number
  created_at?: string
  updated_at?: string
}

export default class AccountVacanciesIntegrationsService extends ApiService {
  protected route: string = 'users-management/integrations'

  async importVacancy({ baseUrl, token, integrationId }: ImportVacancyParams): Promise<void> {
    await this.requestService.request({
      url: `/api/v1/yavagro/users-management/integrations/${integrationId}`,
      baseURL: baseUrl,
      method: 'PUT',
      headers: { 'Authorization-SF-Token': token }
    })
  }

  async getIntegrations({ baseUrl, token }: IntegrationsParams): Promise<VacancyIntegrationModel | null> {
    const { data } = await this.requestService.request<{ data?: unknown[] }>({
      url: '/api/v1/yavagro/users-management/integrations/my',
      baseURL: baseUrl,
      params: { token }
    })

    if (!Array.isArray(data?.data)) return null

    const integration = data.data.find(
      (item): item is IntegrationData => isUnknownObject(item) && item.name === 'headhunter'
    )

    return integration ? new VacancyIntegrationModel(integration) : null
  }
}
